/**
 * resolveAreaLabel — a human label for an area group header.
 *
 * IDI-459 (parent IDI-455): both builders grouped lines with
 * `label: item.areaLabel || areaId`, which puts a RAW ID in front of the user
 * whenever a line has no `areaLabel` — common on change-order lines and on
 * migrated job lines. `groupLinesByArea` also substitutes the internal
 * sentinel `'uncategorized'` for a line with no `areaId` at all, which then
 * rendered verbatim as a header.
 *
 * Resolution order:
 *   1. the line's own label (what the Add-Item cascade stamps)
 *   2. the seeded area's name for that id
 *   3. a plain word — never an id, never the sentinel
 */
import { AREAS } from '../../../quote-builder/seedCatalog';

// Not exported: a label the tests assert by value, not a shared constant.
const FALLBACK_AREA_LABEL = 'Other items';

export function resolveAreaLabel(item, areaId) {
  const own = item?.areaLabel || item?.area_label;
  if (own) return own;
  const seeded = AREAS.find((a) => a.id === areaId);
  if (seeded?.label) return seeded.label;
  return FALLBACK_AREA_LABEL;
}

export default resolveAreaLabel;
